module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAAdElEQVQYlc3QPQ6CUBAE4A+iPQW9V7DmLCYeyHNwEAt6rmBrRS0xmjXvJRsaW6aanf3JzDbPvpfwKbSpUusP9jIwFvc1QaDWY8TsMOO0WX7gHBcWXPFOzeChLTXmHbc0EDw0+ZNHTMXXgFeIh7S14lL4rwlfZdAXJYs+iMMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.png
// module id = w80D
// module chunks = 1